import AuthRepository from '@/business/modules/auth/auth.repository';
import type { IRegisterUserRequest, IRegisterUserResponse, IUpdateUserInformation, IVerifyOtpResponse } from '@/business/modules/auth/auth.model';

class AuthService {
	static #instance: AuthService;
	private readonly repository;

	private constructor() {
		this.repository = AuthRepository.getInstance();
	}

	public static getInstance(): AuthService {
		if (!AuthService.#instance) {
			AuthService.#instance = new AuthService();
		}

		return AuthService.#instance;
	}

	signup(data: IRegisterUserRequest): Promise<IRegisterUserResponse> {
		return this.repository.signup(data);
	}

	loginInit(phoneNumber: string) {
		return this.repository.loginInit(phoneNumber);
	}

	verifyOtp(otpCode: string): Promise<IVerifyOtpResponse> {
		return this.repository.verifyOtp(otpCode);
	}

	loginAsAdmin(otpCode: string) {
		return this.repository.loginAsAdmin(otpCode);
	}

	updateUserInformation(userData: IUpdateUserInformation) {
		return this.repository.updateUserInformation(userData);
	}

	loginByRefreshToken() {
		return this.repository.loginByRefreshToken();
	}

	getUserInformation() {
		return this.repository.getUserInformation();
	}
}

export default AuthService;
